// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { Tiles } from 'src/modules/content-tiles/jsx/tiles.jsx';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";


// Stateless components

export function MyProgramRequestsPage(props) {
    
    function renderPageContent(context) {

        var helpers = context['helpers'];
        var requests_link = helpers.getDynamicLinkUrlById('889842');
        var requests_title = 'My online applications';
     
        return (
            <>
                <div className="program-requests__pending__wrapper">
                    <ContextualMessage id="program_requests" />
                    <a href={requests_link} className="program-requests__pending">{requests_title}</a>
                </div>
                <Tiles key={context['current_page']} columns="three" />
            </>
        );
    }


    //
    // Render
    //

    return (
        <PortalContext.Consumer>
            {renderPageContent}
        </PortalContext.Consumer>
    );

};
